module.exports = __webpack_public_path__ + "static/media/team-image-3.f6d90ee9.webp";